import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import TabStrip2Type from '@/Controls/TabStrip2';
import RoleAssignmentViewModelType from '@/ViewModels/Controls/RoleAssignmentViewModel';

export default class RoleAssignment extends Control {

    private TabStrip2 = ComponentManager.getControl<typeof TabStrip2Type>('TabStrip2');
    private jQueryControl: JQuery;
    private tabStrip: TabStrip2Type;

    public constructor(private typedViewModel: RoleAssignmentViewModelType, private element?: JQuery<HTMLElement>) {
        super(typedViewModel, element);

        this.onWidgetCreated(this.widgetCreatedCallback.bind(this));
    }

    /**
     * @override
     */
    public getControl() {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.jQueryControl = this.element || $('<div><div class="c-content"></div></div>');
        this.widget(null);
        return this.jQueryControl;
    }

    private widgetCreatedCallback(widget: null) {
        this.applyBindings(this.jQueryControl, {
            controlName: 'roleassignment',

            loader: this.typedViewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.typedViewModel.tooltip,

            invalid: this.typedViewModel.invalidationText,

            visible: this.typedViewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    var styles = [];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    const states = [];

                    if (this.typedViewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.typedViewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.typedViewModel.tabStrip != null) {
            this.tabStrip = new this.TabStrip2(this.typedViewModel.tabStrip);
            this.typedViewModel.executeBusilyAsync(async () => {
                const tuple = await this.tabStrip.getTupleAsync();
                const $content = this.jQueryControl.find('.c-content');
                tuple.control.appendTo($content);
            });

        }
    }
}

ComponentManager.setControl('RoleAssignment', RoleAssignment, 'RADPresentation.HTMLClient.DefaultViewExtensions');